/**
 * Guest browsing helpers: unauthenticated users can browse shops. Jobs,
 * Build, Dashboard, and Page require sign-in.
 */

/** Paths guests may open inside the authenticated app shell. */
export function isGuestAllowedPath(path: string): boolean {
  if (path === '/app' || path === '/app/home' || path === '/app/mall' || path === '/app/shops' || path === '/app/cv') return true
  if (path === '/app/settings/privacy' || path === '/app/settings/terms') return true
  if (path.startsWith('/app/c/') || path.startsWith('/app/u/')) return true
  return false
}

export function useGuestMode() {
  const { isAuthenticated, ready } = useAuth()
  const { t } = useKawadernaI18n()
  const { show } = useToast()
  const { openAuth } = useAuthModal()

  const isGuest = computed(() => ready.value && !isAuthenticated.value)

  /**
   * Prompt sign-in in the popup on the current page.
   * Safe to import from middleware for [isGuestAllowedPath] alone.
   */
  function requireLogin(messageKey = 'guest.loginRequired'): false {
    openAuth('signin')
    if (messageKey !== 'guest.loginRequired') {
      show(t(messageKey))
    }
    return false
  }

  return { isGuest, isGuestAllowedPath, requireLogin }
}
